import React, { useState, useEffect, useRef } from "react";
import CoolAreasItem from "./CoolAreasItem";
import CoolAreasForm from "./CoolAreasForm";
import Collapse from "@mui/material/Collapse";
import LoadingSkeleton from "../../../../Components/AllComponents/LoadingSkeleton";
import "../BaseStyles.css";
import axios from "axios";

const CoolAreasTable = () => {
  const [formView, setFormView] = useState(false);
  const [updateData, setUpdateData] = useState(false);
  const [allRecommendation, setAllRecommendation] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `https://resto-app-user.herokuapp.com/recommendation/get-all-cool-areas`
      );
      setAllRecommendation(res.data.data);
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    let mount = true;
    if (mount) {
      fetchData();
    }
    return () => {
      mount = false;
    };
  }, [updateData]);

  return (
    <div
      className="wrapper"
      style={{ backgroundColor: "white", padding: "10px 5px 20px" }}
    >
      <div className="recommendation-table">
        <div className="recommendation-table-header">
          <p>All Cool Areas</p>
          <div>
            <button
              className="btn__"
              style={{ backgroundColor: "#EF3340", color: "white" }}
              onClick={() => setFormView(true)}
            >
              Add Cool Areas
            </button>
          </div>
        </div>
        <Collapse in={formView}>
          <CoolAreasForm
            setFormView={setFormView}
            setUpdateData={setUpdateData}
          />
        </Collapse>
        <div className="border-t border-gray-300"></div>
        {isLoading ? (
          <LoadingSkeleton />
        ) : (
          allRecommendation.map((item, index) => {
            return (
              <CoolAreasItem item={item} index={index + 1} key={item._id} />
            );
          })
        )}
      </div>
    </div>
  );
};

export default CoolAreasTable;
